<template>
  <div class="smb-sales_container">
    <div class="smb-sales_container_title">
      <div class="smb-sales_container_title__left">Support Document</div>
      <div
        class="smb-sales_container_title__right"
        v-if="
          (isApply || isResubmit || isRenew || (isEdit && isSenior)) &&
            isShowFileDown
        "
        @click="handleDownloadTemplate"
      >
        Download templates
      </div>
    </div>
    <div class="smb-sales_container_table" v-if="isDetail">
      <el-table border :data="detailData">
        <el-table-column
          label="Items"
          prop="items"
          min-width="219"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            {{ getItemName(row.typeNumber) }}
          </template>
        </el-table-column>
        <el-table-column
          label="File Name"
          prop="fileName"
          min-width="298"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <span
              v-if="row.fileName"
              class="click-span"
              @click="handleOpenFile(row.fileUrl, row)"
              >{{ row.fileName }}</span
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Upload Datetime"
          prop="createTime"
          min-width="150"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <span v-if="row.createTime">
              {{ dayjs(row.createTime).format("YYYY-MM-DD") }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="smb-sales_container_table" v-if="isSeniorEditApprove">
      <el-table border :data="seniorEditApproveDetail">
        <el-table-column
          label="Items"
          prop="items"
          min-width="219"
          show-overflow-tooltip
        />

        <el-table-column
          label="New File Name"
          prop="newFileName"
          min-width="298"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <span
              v-if="row.newFileName"
              class="click-span"
              @click="handleOpenFile(row.newFileId)"
            >
              {{ row.newFileName }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Original File Name"
          prop="oldFileName"
          min-width="298"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <span
              v-if="row.oldFileName"
              class="click-span"
              @click="handleOpenFile(row.oldFileId)"
              >{{ row.oldFileName }}</span
            >
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Upload Datetime"
          prop="createTime"
          min-width="150"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <span v-if="row.createTime">
              {{ dayjs(row.createTime).format("YYYY-MM-DD") }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="smb-sales_container_table"
      v-if="isApply || isEdit || isRenew || isResubmit"
    >
      <el-table border :data="tableList">
        <el-table-column
          label="Items"
          prop="items"
          min-width="219"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <span
              :class="{
                'required-label': row.isRequired
              }"
              >{{ row.items }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="File Type"
          prop="fileTips"
          min-width="713"
          show-overflow-tooltip
        />
        <el-table-column
          label="File Name"
          prop="fileName"
          min-width="298"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <template v-if="row.isUpLoad">
              <div class="form-container_table__upload">
                <el-progress
                  class="form-container_table__uploadLine"
                  :percentage="row.progress"
                  :stroke-width="2"
                  :show-text="false"
                />
                <img
                  src="@/assets/delete_circle.svg"
                  width="24"
                  height="24"
                  @click="cancelUpload(row)"
                  alt=""
                />
              </div>
            </template>
            <template v-else>
              <div v-if="row.fileName" class="file-name">
                <span
                  @click="handleOpenFile(row.fileId, row)"
                  class="file-name_desc"
                >
                  {{ row.fileName }}
                </span>
                <img
                  v-if="isShowUpload"
                  src="@/assets/delete_circle.svg"
                  width="24"
                  height="24"
                  @click="handleRemoveFile(row)"
                  alt=""
                />
              </div>
              <span v-else>
                -
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Operation" min-width="120" fixed="right">
          <template #default="{row}">
            <el-upload
              v-if="isShowUpload"
              class="upload-demo"
              action=""
              name="file"
              accept=".jpg,.jpeg,.gif,.png,.bmp,.rar,.zip,.pptx,.ppt,.docx,.doc,.pdf"
              :show-file-list="false"
              :http-request="fileInfo => uploadFile(fileInfo, row)"
            >
              <el-button type="text">Upload</el-button>
            </el-upload>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getNum, saveFileInfo, uploadFile } from "../../../../../utils/upload";
import Big from "big.js";
import API from "../../../../../api";
import APIS from "../../../../../api/fileAxios/fileAxios";
import dayjs from "dayjs";
import { mapState } from "vuex";
import { recordUserAction } from "../../../../../utils/recordUserAction.js";
export default {
  name: "supportDocument",
  props: {
    // 编辑类型 基础 base 或者 高级senior 默认基础
    mode: {
      type: String,
      default: "base"
    },
    isApply: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Array,
      default: () => []
    },
    isRenew: {
      type: Boolean,
      default: false
    },
    isResubmit: {
      type: Boolean,
      default: false
    },
    //是否是高级编辑审批页面
    isSeniorEditApprove: {
      type: Boolean,
      default: false
    },
    // 编辑修改后的数据
    oldEditDetail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableList: [
        {
          items: "Business License",
          fileType: "CERTIFICATE_LICENSE",
          fileTips:
            "Max file size: 50MB. Accepted formats: JPG, JPEG, PNG, PPT, DOC, DOCX, PDF, RAR, ZIP",
          isRequired: false,
          fileName: "", // 文件名
          fileId: "", // 文件id
          isUpLoad: false, // 是否上传
          progress: 0, // 进度 上传完之后清空
          client: null // 取消上传可通过这个
        },
        {
          items: "Business Plan",
          fileType: "BUSINESS_PLAN",
          fileTips:
            "Max file size: 50MB. Accepted formats: JPG, JPEG, PNG, PPT, DOC, DOCX, PDF, RAR, ZIP",
          isRequired: false,
          fileName: "",
          fileId: "",
          isUpLoad: false,
          progress: 0,
          client: null
        },
        {
          items: "Signed Partnership Proposal",
          fileType: "COOPERATION_PLAN",
          fileTips:
            "Max file size: 50MB. Accepted formats: JPG, JPEG, PNG, PPT, DOC, DOCX, PDF, RAR, ZIP",
          isRequired: true,
          fileName: "",
          isUpLoad: false,
          progress: 0,
          fileId: "",
          client: null
        }
      ],
      isInit: !this.isApply
    };
  },
  watch: {
    "partnerContractInfo.partnerType"(newVal) {
      if (this.isInit) return;
      if (newVal === "VAD") {
        const hasVad = this.tableList.find(
          item => item.fileType === "VAD_AGREEMENT"
        );
        if (!hasVad) {
          this.tableList.push({
            items: "VAD Agreement",
            fileType: "VAD_AGREEMENT",
            fileTips:
              "Max file size: 50MB. Accepted formats: JPG, JPEG, PNG, PPT, DOC, DOCX, PDF, RAR, ZIP",
            isRequired: true,
            fileName: "",
            isUpLoad: false,
            progress: 0,
            fileId: "",
            client: null
          });
        }
      } else {
        this.tableList = this.tableList.filter(
          item => item.fileType !== "VAD_AGREEMENT"
        );
      }
    }
  },
  computed: {
    ...mapState("smbSales", ["partnerContractInfo", "selectCountryAndRegion"]),
    isShowUpload() {
      if (this.isApply || this.isRenew || this.isResubmit) {
        return true;
      } else if (this.isEdit && this.isSenior) {
        return true;
      }
      return false;
    },
    isShowFileDown() {
      return !!this.selectCountryAndRegion.country;
    },
    // 是否高级编辑
    isSenior() {
      return this.mode === "senior";
    },
    // 高级编辑审批详情的数据
    seniorEditApproveDetail() {
      // 不是高级编辑审批详情直接返回空数组
      if (!this.isSeniorEditApprove) return [];
      let tableList = [];
      this.detailData.forEach(item => {
        let fileInfo = {};
        // 文件类型
        fileInfo.items = this.getItemName(item.typeNumber);
        switch (item.typeNumber) {
          case 11:
            // 如果旧值带有营业执照副本 certificateLicenseUrl 说明详情给的是新的值， 否者 详情是旧值 下方亦是如此
            Object.assign(
              fileInfo,
              this.buildSeniorEditApproveFileInfo(item, "certificateLicenseUrl")
            );
            break;
          case 12:
            // 如果旧值带有业务规划书 businessPlanUrl
            Object.assign(
              fileInfo,
              this.buildSeniorEditApproveFileInfo(item, "businessPlanUrl")
            );
            break;
          case 10:
            // 如果旧值带有合作计划书 cooperationPlanUrl
            Object.assign(
              fileInfo,
              this.buildSeniorEditApproveFileInfo(item, "cooperationPlanUrl")
            );
            break;
          default:
            fileInfo.oldFileId = item.fileUrl;
            fileInfo.oldFileName = item.fileName;
            fileInfo.newFileId = "";
            fileInfo.newFileName = "";
            fileInfo.createTime = "";
            break;
        }
        tableList.push(fileInfo);
      });
      return tableList;
    }
  },
  methods: {
    dayjs,
    getItemName(typeNumber) {
      switch (typeNumber) {
        case 14:
          return "VAD Agreement";
        case 11:
          return "Business License";
        case 12:
          return "Business Plan";
        case 10:
          return "Signed Partnership Proposal";
        case 3:
          return "Authorization Certificate";
        case 1:
          return "Type of Contract";
        default:
          return "-";
      }
    },
    async uploadFile({ file }, row) {
      if (file.size === 0) {
        this.$message.error({
          message: "The file size upon upload is zero.",
          type: "warning"
        });
        return;
      }
      if (file.size > 52428800) {
        this.$message.error({
          message: "Error: File size exceeds the limit",
          type: "warning"
        });
        return;
      }
      await this.$store.dispatch("getuser");
      // 保存文件的信息
      let saveFileParams = {};
      const uploadParams = {
        file,
        config: {
          originalFilename: file.name,
          contentType: file.type,
          service: "customer",
          module: row.fileType,
          userId: this.$store.state.user.userId,
          privateBucket: true
        },
        onProgress: p => {
          row.progress = getNum(
            Big(getNum(p))
              .times(100)
              .toFixed(2)
          );
        },
        cancel: client => {
          row.client = client;
        }
      };
      // 开启上传
      row.isUpLoad = true;
      try {
        const { res, name } = await uploadFile(uploadParams);
        if (res.status === 200) {
          saveFileParams = {
            service: "customer",
            size: file.size,
            objectName: name,
            module: row.fileType,
            userId: this.$store.state.user.userId,
            contentType: file.type,
            originalFilename: file.name,
            privateBucket: true
          };
          const { status, data } = await saveFileInfo(saveFileParams);
          if (status === "200") {
            const uploadParam = {
              type: row.fileType,
              fileId: data.id,
              fileName: data.name,
              downloadUrl: data.path
            };
            API.postOssUpload(uploadParam).then(res => {
              if (res.data.data) {
                // 存id
                row.fileId = res.data.data;
                row.fileName = data.name;
                row.isUpLoad = false;
                row.progress = 0;
                row.client = null;
              }
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    cancelUpload(row) {
      row.client.cancel();
      row.client = null;
      row.progress = 0;
      row.isUpLoad = false;
      row.fileName = "";
    },
    handleRemoveFile(row) {
      row.fileId = "";
      row.fileName = "";
    },
    handleOpenFile(fileId, row) {
      if (row && row.objectType === 3) {
        recordUserAction("electro_auth_download_event");
      }
      APIS.getAliOSSDownloadInfo(fileId)
        .then(res => {
          let { status, data } = res.data;
          if (Number(status) === 200) {
            window.open(data.fileInfo.url);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 设置formData
    setFormData({ formData, partnerType }) {
      if (!formData) return;

      if (partnerType === "VAD") {
        const hasVad = this.tableList.find(
          item => item.fileType === "VAD_AGREEMENT"
        );
        if (!hasVad) {
          this.tableList.push({
            items: "VAD Agreement",
            fileType: "VAD_AGREEMENT",
            fileTips:
              "Max file size: 50MB. Accepted formats: JPG, JPEG, PNG, PPT, DOC, DOCX, PDF, RAR, ZIP",
            isRequired: true,
            fileName: "",
            isUpLoad: false,
            progress: 0,
            fileId: "",
            client: null
          });
        }
      }

      formData.forEach(item => {
        const tableItem = this.tableList.find(
          tableItem => tableItem.items === this.getItemName(item.objectType)
        );
        if (tableItem) {
          tableItem.fileId = item.attachmentUrl;
          tableItem.fileName = item.name;
        }
      });

      this.$nextTick(() => {
        this.isInit = false;
      });
    },
    handleDownloadTemplate() {
      window.open('https://ruijie.feishu.cn/wiki/KGfswFhS4iAhOIk68STcd0wEnvq');
      // const params = {
      //   countryCode: this.selectCountryAndRegion.country,
      //   signType: this.partnerContractInfo.partnerType
      // };
      // API.getFileBySingType(params).then(res => {
      //   let {status, data} = res.data;
      //   if (Number(status) === 200) {
      //     if (data) {
      //       this.handleOpenFile(data);
      //     } else {
      //       this.$message.error('Contract templates are not available for the current authorized region');
      //     }
      //   }
      // }).catch((e) => {
      //   console.log(e);
      // });
    },
    // 获取formData
    getFormData() {
      if (this.isDetail) return;
      try {
        this.tableList.forEach((item, index) => {
          if (item.isRequired) {
            // 是否上传了文件
            if (!item.fileId) {
              throw new Error(
                index === 2
                  ? "please upload Signed Partnership Proposal"
                  : "please upload Vad Agreement"
              );
            }
          }
        });
      } catch (e) {
        this.$message.error({
          message: e.message,
          type: "success"
        });
        return false;
      }

      return {
        // 营业执照副本
        certificateLicenseUrl: this.tableList[0].fileId,
        // 业务规划书
        businessPlanUrl: this.tableList[1].fileId,
        // 合作计划书
        cooperationPlanUrl: this.tableList[2].fileId,

        vadAgreement:
          this.partnerContractInfo.partnerType === "VAD"
            ? this.tableList[3].fileId
            : ""
      };
    },
    // 用于高级编辑详情组装fileInfo的函数
    buildSeniorEditApproveFileInfo(item, type) {
      let fileInfo = {};
      if (this.oldEditDetail.hasOwnProperty(type)) {
        let oldFileInfoString = this.oldEditDetail[type];
        // 没值说明之前没有值
        if (!oldFileInfoString) {
          fileInfo.oldFileId = "";
          fileInfo.oldFileName = "";
        } else {
          let oldFileInfo = JSON.parse(oldFileInfoString);
          fileInfo.oldFileId = oldFileInfo[0].attachmentUrl;
          fileInfo.oldFileName = oldFileInfo[0].name;
        }
        // 旧数据存在这个字段 说明详情中的这个字段是新的
        fileInfo.newFileId = item.fileUrl;
        fileInfo.newFileName = item.fileName;
        fileInfo.createTime = item.createTime;
      } else {
        fileInfo.oldFileId = item.fileUrl;
        fileInfo.oldFileName = item.fileName;
        fileInfo.newFileId = "";
        fileInfo.newFileName = "";
        fileInfo.createTime = "";
      }
      return fileInfo;
    }
  }
};
</script>

<style scoped>
.form-container_table__upload {
  display: flex;
  padding-top: 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.form-container_table__upload .form-container_table__uploadLine {
  flex: 1;
}

.file-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.file-name .file-name_desc {
  width: auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #2a82e4;
  cursor: pointer;
}

.required-label {
  position: relative;
}

.required-label:before {
  position: absolute;
  content: "*";
  color: #e60039;
  font-size: 14px;
  left: -10px;
  top: -8px;
}

.click-span {
  color: #2a82e4;
  cursor: pointer;
}

.smb-sales_container_title__right {
  color: #2a82e4 !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/channelAgreement/twentyTwentyFive/SBG/components/supportDocument.vue